import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import AddTask from './pages/AddTask';
import { TaskProvider } from './context/TaskContext';
import SideBar from './components/SideBar';
import './styles/global.css';


const App = () => {
  return (
    <Router>
      <TaskProvider>
        <div className='container-app'>
        <SideBar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/add-task" element={<AddTask />} />
            <Route path="/add-task/:id" element={<AddTask />} />
          </Routes>
        </main>
        </div>
      </TaskProvider>
    </Router>
  );
};

export default App;